
export default class Intro {
  constructor(element) {
    this.element = element;
    this.trigger = document.querySelector(".js-intro-trigger");
    this.letter = this.element.querySelector(".c-letter")
  }

  mount() {
    var windowHeight = window.innerHeight;
    let progress=0;

    let lastKnownScrollPosition = 0;
    let lastScrollWasInArea = false;
    let ticking = false;

    function updateScroll() {

      var containerTop =  document.querySelector(".js-intro").getBoundingClientRect().top;

      let isInCalculatonArea = window.scrollY > windowHeight
      let isBeforeArea = window.scrollY < 1;
      let isAfterArea = containerTop < windowHeight;

      // scroll speed intro text
      if (window.scrollY < windowHeight && window.scrollY > (windowHeight*0.4) ) {
        document.querySelector(".a-hintro__text").style.opacity = ((((window.scrollY-windowHeight*0.4)/(windowHeight*0.6))));
      }

      if(window.scrollY > (windowHeight*0.9)){
        document.querySelector(".a-hintro__subtext").classList.add("a-hintro__text--visible")
      } else {
        if(document.querySelector(".a-hintro__subtext").classList.contains("a-hintro__text--visible")) {
          document.querySelector(".a-hintro__subtext").classList.remove("a-hintro__text--visible")
        }
      }

      if (window.scrollY < (windowHeight*0.5)) {
        document.querySelector(".js-intro-scroll").style.opacity = 1 - (window.scrollY/(windowHeight*0.5));
      }

      if (isInCalculatonArea) {
        lastScrollWasInArea = true;
      } else {
        if (lastScrollWasInArea) {
          if(isBeforeArea) {
            progress=0;
          }
          if(isAfterArea) {
            progress=1;
          }
        }
        lastScrollWasInArea = false;
      }
    }

    document.addEventListener("scroll", (event) => {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateScroll(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    });
  }

  updateProgress() {

  }
}
